import React from 'react';
import ReactDOM from 'react-dom';
import ShiftState from '../ShiftState';
import StateFactory from '../StateFactory';
import EmptyStateComponent from './EmptyStateComponent';


class EmptyState extends ShiftState {

  get name() {
    return 'empty_state';
  }


  preload() {
    ReactDOM.render(<EmptyStateComponent />, this.node);

    return super.preload();
  }

}

StateFactory.register('empty_state', EmptyState, 10);

export default EmptyState;
